import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { IMultiSelectOption, MultipleSelect } from '../MultipleSelect';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form';

interface IFormMultiSelectProps {
  name: string;
  placeholder?: string;
  disabled?: boolean;
  label?: ReactNode;
  className?: string;
  options?: IMultiSelectOption[];
  onChange?: (values: string[]) => void;
  creatable?: boolean;
  maxCount?: number;
}

const FormMultiSelect: React.FunctionComponent<IFormMultiSelectProps> = ({
  name,
  placeholder = '',
  disabled = false,
  label = '',
  className = '',
  options = [],
  onChange,
  creatable = false,
  maxCount,
}) => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          {!!label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <MultipleSelect
              options={options}
              placeholder={placeholder}
              onValueChange={(values) => {
                field.onChange(values);
                onChange?.(values);
              }}
              values={field.value}
              disabled={disabled}
              creatable={creatable}
              maxCount={maxCount}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default FormMultiSelect;
